import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem("av_token");
        if (!token) {
            setUser(false);
            setReady(true);
            return;
        }
        api
            .get("/auth/me")
            .then(({ data }) => setUser(data))
            .catch(() => {
                localStorage.removeItem("av_token");
                setUser(false);
            })
            .finally(() => setReady(true));
    }, []);

    const login = (token, u) => {
        localStorage.setItem("av_token", token);
        setUser(u);
    };
    const updateUser = (patch) => setUser((prev) => (prev ? { ...prev, ...patch } : prev));
    const logout = () => {
        localStorage.removeItem("av_token");
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, ready, login, updateUser, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
